/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Center_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Bottom center" |
*
* @param {Position_Bottom_Center_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_center_aria_label = /** @type {((inputs?: Position_Bottom_Center_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Center_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En bas au centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte unten")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo en el centro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("底部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निचला बीच का")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro inferior")
	return /** @type {LocalizedString} */ ("Bottom center")
});